import { ConfirmModal } from "../../../../common/modals/PopupModals";

const ConfirmTemplateDeleteModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <ConfirmModal
    shouldShow={shouldShow}
    hideModal={hideModal}
    title="Delete Template"
    confirmText="Delete"
    cancelText="Cancel"
    confirmAction={confirmAction}
    cancelAction={hideModal}
  >
    <p>
      Deleting the template will erase all data you&apos;ve entered so
      far for this template. <b>This action cannot be undone.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </ConfirmModal>
);

export default ConfirmTemplateDeleteModal;
